import { makePatchRequest } from 'owa-ows-gateway';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { trace } from 'owa-trace';
import { ActivityFeedSettingIds } from '../service/ActivityFeedSettingType';
import { ObservableMap } from 'mobx';

const GET_ACTIVITY_FEED_URL: string =
    '/ows/beta/OutlookCloudSettings/settings/account?settingname=notification_settings';
const settingName: string = 'notification_settings';

export function patchActivityFeedSettings(
    newSetting: ObservableMap<ActivityFeedSettingIds, boolean>
): Promise<boolean> {
    const requestString = JSON.stringify(newSetting);
    const jsonArray = [
        {
            name: settingName,
            value: requestString,
            type: 'JSON',
            scope: getUserConfiguration().SessionSettings.UserEmailAddress,
            secondaryKey: settingName,
            itemClass: 'RoamingSetting',
        },
    ];

    // header to override timestamp bypass
    const customHeaders = {
        'x-overridetimestamp': true,
    };

    return makePatchRequest(GET_ACTIVITY_FEED_URL, jsonArray, undefined, undefined, customHeaders)
        .then((response: Response) => {
            return isSuccessStatusCode(response.status);
        })
        .catch(err => {
            trace.warn('Failed to save activity feed settings  ' + err.message);
            return false;
        });
}
